import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import registerErrors from './errors';
import registerProperties from './properties';

const attributesObjRef = {
  valid_nomenclature: {
    serverSide: true,
    values: [
      { id: '1', name: 'Oui' },
      { id: '0', name: 'Non' },
    ],
  },
  temperature_meter: {
    serverSide: true,
    values: [
      { id: '1', name: 'Oui' },
      { id: '0', name: 'Non' },
    ],
  },
  meter_property_name: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
};

const attributesObj = {
  valid_nomenclature: {
    serverSide: true,
    values: ['1'],
  },
  temperature_meter: {
    serverSide: true,
    values: ['1'],
  },
  meter_property_name: {
    serverSide: true,
    type: '$null',
    values: ['O'],
  },
};

export default (store) => {
  store.registerModule(
    ['sensors'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({}),
      }),
      attributesObj,
      attributesObjRef,
      makeQueryParams: makeListRequest({}),
      makeHttpParamsUrl: (id) =>
        `${process.env.MYPREDITY_BASE_URI}/properties/${id}/sensors`,
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'sensors',
    store,
  });

  registerProperties(store);

  basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({});

  basePlugin.onInit(() => {
    store.commit('sensors/SET_ITEMS_PAGE_SIZE', 1);
    store.subscribeAction((action) => {
      if (action.type === 'sensors/properties/addCurrent') {
        store.dispatch('sensors/setUrlParamId', action.payload.id);
      }
    });
  });
  registerErrors(store);
};
